import React, {Component, PureComponent, useCallback, useEffect} from 'react';
import axios from 'axios/index';
import {Link} from 'react-router-dom';
// import * as authService from '../../services/authService';
import * as userService from '../../services/userService';
import {login} from '../../services/authService';
import Form from '../common/Form';
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";

import ReCAPTCHA from "react-google-recaptcha";
import { GoogleReCaptchaProvider, GoogleReCaptcha } from 'react-google-recaptcha-v3';
import getQueryStringParams from '../common/GetQueryStringParams';

import InputRegular from '../common/InputRegular';
import Header from './Header';
import toastr from "toastr";
import http from '../../services/httpService';

class Register extends Form {
    constructor(props) {
        super(props);
        this.state = {
            forbidden: [
                "gmail.com", "yahoo.com", "hotmail.com", "aol.com", "hotmail.co.uk", "hotmail.fr", "msn.com", "yahoo.fr",
                "wanadoo.fr", "orange.fr", "comcast.net", "yahoo.co.uk", "yahoo.com.br", "yahoo.co.in", "live.com", "rediffmail.com", "free.fr",
                "gmx.de", "web.de", "yandex.com", "yandex.ru", "ymail.com", "libero.it", "outlook.com", "uol.com.br", "bol.com.br", "mail.ru",
                "cox.net", "hotmail.it", "sbcglobal.net", "sfr.fr", "live.fr", "verizon.net", "live.co.uk", "googlemail.com", "yahoo.es", "ig.com.br", "live.nl",
                "bigpond.com", "terra.com.br", "yahoo.it", "neuf.fr", "yahoo.de", "alice.it", "rocketmail.com", "att.net", "laposte.net", "facebook.com",
                "bellsouth.net", "yahoo.in", "hotmail.es", "charter.net", "yahoo.ca", "yahoo.com.au", "rambler.ru", "hotmail.de", "tiscali.it",
                "shaw.ca", "yahoo.co.jp", "sky.com", "earthlink.net", "optonline.net", "freenet.de", "t-online.de", "aliceadsl.fr", "virgilio.it",
                "home.nl", "qq.com", "telenet.be", "me.com", "yahoo.com.ar", "tiscali.co.uk", "yahoo.com.mx", "voila.fr", "gmx.net", "mail.com", "planet.nl",
                "tin.it", "live.it", "ntlworld.com", "arcor.de", "yahoo.co.id", "frontiernet.net", "hetnet.nl", "live.com.au", "yahoo.com.sg", "zonnet.nl",
                "club-internet.fr", "juno.com", "optusnet.com.au", "blueyonder.co.uk", "bluewin.ch", "skynet.be", "sympatico.ca", "windstream.net",
                "mac.com", "centurytel.net", "chello.nl", "live.ca", "aim.com", "bigpond.net.au", "protonmail.com", "zohomail.eu",
                "pm.me", "protonmail.ch", "yopmail.com", "sc2hub.com", "mggovernor.com", "sharklasers.com", "guerrillamail.info", "grr.la", "guerrillamail.biz",
                "guerrillamail.com", "guerrillamail.de", "guerrillamail.net", "guerrillamail.org", "guerrillamailblock.com", "pokemail.net",
                "spam4.me", "crepeau12.com", "greencafe24.com", "mail.tm", "mailpoof.com", "getburner.email", "privacy-mail.top", "net-c.nl", "tapi.re", "teaser.fr",
                "mirai.re", "perso.be", "brusseler.com", "inmano.com", "0815.ru", "0wnd.net",
                "0wnd.org", "10minutemail.co.za", "10minutemail.com", "123-m.com", "1fsdfdsfsdf.tk", "1pad.de", "20minutemail.com", "21cn.com", "2fdgdfgdfgdf.tk", "2prong.com", "30minutemail.com", "33mail.com",
                "3trtretgfrfe.tk", "4gfdsgfdgfd.tk", "4warding.com", "5ghgfhfghfgh.tk", "6hjgjhgkilkj.tk", "6paq.com", "7tags.com", "9ox.net", "a-bc.net", "agedmail.com", "ama-trade.de", "amilegit.com", "amiri.net",
                "amiriindustries.com", "anonmails.de", "anonymbox.com", "antichef.com", "antichef.net", "antireg.ru", "antispam.de", "antispammail.de", "armyspy.com", "artman-conception.com", "azmeil.tk", "baxomale.ht.cx", "beefmilk.com", "bigstring.com", "binkmail.com", "bio-muesli.net",
                "bobmail.info", "bodhi.lawlita.com", "bofthew.com", "bootybay.de", "boun.cr", "bouncr.com", "breakthru.com",
                "brefmail.com", "bsnow.net", "bspamfree.org", "bugmenot.com", "bund.us", "burstmail.info", "buymoreplays.com",
                "byom.de", "c2.hu", "card.zp.ua", "casualdx.com", "cek.pm", "centermail.com", "centermail.net", "chammy.info",
                "childsavetrust.org", "chogmail.com", "choicemail1.com", "clixser.com", "cmail.net", "cmail.org", "coldemail.info", "cool.fr.nf",
                "courriel.fr.nf", "courrieltemporaire.com", "crapmail.org", "cust.in", "cuvox.de", "d3p.dk", "dacoolest.com", "dandikmail.com",
                "dayrep.com", "dcemail.com", "deadaddress.com", "deadspam.com", "delikkt.de", "despam.it", "despammed.com",
                "devnullmail.com", "dfgh.net", "digitalsanctuary.com", "dingbone.com", "disposableaddress.com", "disposableemailaddresses.com", "disposableinbox.com", "dispose.it",
                "dispostable.com", "dodgeit.com", "dodgit.com", "donemail.ru", "dontreg.com", "dontsendmespam.de", "drdrb.net",
                "dump-email.info", "dumpandjunk.com", "dumpyemail.com", "e-mail.com", "e-mail.org", "e4ward.com", "easytrashmail.com", "einmalmail.de",
                "einrot.com", "eintagsmail.de", "emailgo.de", "emailias.com", "emaillime.com", "emailsensei.com", "emailtemporanea.com", "emailtemporanea.net",
                "emailtemporar.ro", "emailtemporario.com.br", "emailthe.net", "emailtmp.com", "emailwarden.com", "emailx.at.hm", "emailxfer.com",
                "emeil.in", "emeil.ir", "emz.net", "ero-tube.org", "evopo.com", "explodemail.com", "express.net.ua",
                "eyepaste.com", "fakeinbox.com", "fakeinformation.com", "fansworldwide.de", "fantasymail.de", "fightallspam.com", "filzmail.com", "fivemail.de",
                "fleckens.hu", "frapmail.com", "friendlymail.co.uk", "fuckingduh.com", "fudgerub.com", "fyii.de", "garliclife.com",
                "gehensiemirnichtaufdensack.de", "get2mail.fr", "getairmail.com", "getmails.eu", "getonemail.com", "giantmail.de", "girlsundertheinfluence.com",
                "gishpuppy.com", "gmial.com", "goemailgo.com", "gotmail.net", "gotmail.org", "gotti.otherinbox.com", "great-host.in",
                "greensloth.com", "grr.la", "gsrv.co.uk", "guerillamail.biz", "guerillamail.com", "guerrillamail.biz", "guerrillamail.com",
                "guerrillamail.de", "guerrillamail.info", "guerrillamail.net", "guerrillamail.org", "guerrillamailblock.com", "gustr.com", "harakirimail.com", "hat-geld.de", "hatespam.org",
                "herp.in", "hidemail.de", "hidzz.com", "hmamail.com", "hopemail.biz", "ieh-mail.de", "ikbenspamvrij.nl",
                "imails.info", "inbax.tk", "inbox.si", "inboxalias.com", "inboxclean.com", "inboxclean.org", "infocom.zp.ua", "instant-mail.de",
                "ip6.li", "irish2me.com", "iwi.net", "jetable.com", "jetable.fr.nf", "jetable.net", "jetable.org", "jnxjn.com",
                "jourrapide.com", "jsrsolutions.com", "kasmail.com", "kaspop.com", "killmail.com", "killmail.net", "klassmaster.com", "klzlk.com",
                "koszmail.pl", "kurzepost.de", "lawlita.com", "letthemeatspam.com", "lhsdv.com", "lifebyfood.com", "link2mail.net", "litedrop.com",
                "lol.ovpn.to", "lolfreak.net", "lookugly.com", "lortemail.dk", "lr78.com", "lroid.com", "lukop.dk", "m21.cc",
                "mail-filter.com", "mail-temporaire.fr", "mail.by", "mail.mezimages.net", "mail.zp.ua", "mail1a.de", "mail21.cc", "mail2rss.org", "mail333.com",
                "mailbidon.com", "mailbiz.biz", "mailblocks.com", "mailbucket.org", "mailcat.biz", "mailcatch.com", "mailde.de",
                "mailde.info", "maildrop.cc", "maileimer.de", "mailexpire.com", "mailfa.tk", "mailforspam.com", "mailfreeonline.com",
                "mailguard.me", "mailin8r.com", "mailinater.com", "mailinator.com", "mailinator.net", "mailinator.org", "mailinator2.com", "mailincubator.com",
                "mailismagic.com", "mailme.lv", "mailme24.com", "mailmetrash.com", "mailmoat.com", "mailms.com", "mailnesia.com", "mailnull.com",
                "mailorg.org", "mailpick.biz", "mailrock.biz", "mailscrap.com", "mailshell.com", "mailsiphon.com", "mailtemp.info", "mailtome.de",
                "mailtothis.com", "mailtrash.net", "mailtv.net", "mailtv.tv", "mailzilla.com", "makemetheking.com", "manybrain.com", "mbx.cc",
                "mega.zik.dj", "meinspamschutz.de", "meltmail.com", "messagebeamer.de", "mezimages.net", "ministry-of-silly-walks.de", "mintemail.com", "misterpinball.de",
                "moncourrier.fr.nf", "monemail.fr.nf", "monmail.fr.nf", "monumentmail.com", "mt2009.com", "mt2014.com", "mycard.net.ua",
                "mycleaninbox.net", "mymail-in.net", "mypacks.net", "mypartyclip.de", "myphantomemail.com", "mysamp.de", "mytempemail.com",
                "mytempmail.com", "mytrashmail.com", "nabuma.com", "neomailbox.com", "nepwk.com", "nervmich.net", "nervtmich.net",
                "netmails.com", "netmails.net", "neverbox.com", "nice-4u.com", "nincsmail.hu", "nnh.com", "no-spam.ws",
                "noblepioneer.com", "nomail.pw", "nomail.xl.cx", "nomail2me.com", "nomorespamemails.com", "nospam.ze.tc", "nospam4.us", "nospamfor.us", "nospammail.net",
                "notmailinator.com", "nowhere.org", "nowmymail.com", "nurfuerspam.de", "nus.edu.sg", "objectmail.com", "obobbo.com",
                "odnorazovoe.ru", "oneoffemail.com", "onewaymail.com", "onlatedotcom.info", "online.ms", "opayq.com", "ordinaryamerican.net", "otherinbox.com",
                "ovpn.to", "owlpic.com", "pancakemail.com", "pcusers.otherinbox.com", "pjjkp.com", "plexolan.de", "poczta.onet.pl",
                "politikerclub.de", "poofy.org", "pookmail.com", "privacy.net", "privatdemail.net", "proxymail.eu", "prtnx.com",
                "putthisinyourspamdatabase.com", "putthisinyourspamdatabase.com", "qq.com", "quickinbox.com", "rcpt.at", "reallymymail.com",
                "realtyalerts.ca", "recode.me", "recursor.net", "reliable-mail.com", "rhyta.com", "rmqkr.net", "royal.net", "rtrtr.com", "s0ny.net",
                "safe-mail.net", "safersignup.de", "safetymail.info", "safetypost.de", "saynotospams.com", "schafmail.de",
                "schrott-email.de", "secretemail.de", "secure-mail.biz", "senseless-entertainment.com", "services391.com",
                "sharklasers.com", "shieldemail.com", "shiftmail.com", "shitmail.me", "shitware.nl", "shmeriously.com",
                "shortmail.net", "sibmail.com", "sinnlos-mail.de", "slapsfromlastnight.com", "slaskpost.se", "smashmail.de",
                "smellfear.com", "snakemail.com", "sneakemail.com", "sneakmail.de", "snkmail.com", "sofimail.com", "solvemail.info",
                "sogetthis.com", "soodonims.com", "spam4.me", "spamail.de", "spamarrest.com", "spambob.net", "spambog.ru", "spambox.us",
                "spamcannon.com", "spamcannon.net", "spamcon.org", "spamcorptastic.com", "spamcowboy.com", "spamcowboy.net",
                "spamcowboy.org", "spamday.com", "spamex.com", "spamfree.eu", "spamfree24.com", "spamfree24.de", "spamfree24.org",
                "spamgoes.in", "spamgourmet.com", "spamgourmet.net", "spamgourmet.org", "spamherelots.com", "spamherelots.com",
                "spamhereplease.com", "spamhereplease.com", "spamhole.com", "spamify.com", "spaml.de", "spammotel.com",
                "spamobox.com", "spamslicer.com", "spamspot.com", "spamthis.co.uk", "spamtroll.net", "speed.1s.fr",
                "spoofmail.de", "stuffmail.de", "super-auswahl.de", "supergreatmail.com", "supermailer.jp", "superrito.com",
                "superstachel.de", "suremail.info", "talkinator.com", "teewars.org", "teleworm.com", "teleworm.us", "temp-mail.org",
                "temp-mail.ru", "tempe-mail.com", "tempemail.co.za", "tempemail.com", "tempemail.net", "tempemail.net",
                "tempinbox.co.uk", "tempinbox.com", "tempmail.eu", "tempmaildemo.com", "tempmailer.com", "tempmailer.de",
                "tempomail.fr", "temporaryemail.net", "temporaryforwarding.com", "temporaryinbox.com", "temporarymailaddress.com",
                "tempthe.net", "thankyou2010.com", "thc.st", "thelimestones.com", "thisisnotmyrealemail.com", "thismail.net",
                "throwawayemailaddress.com", "tilien.com", "tittbit.in", "tizi.com", "tmailinator.com", "toomail.biz",
                "topranklist.de", "tradermail.info", "trash-mail.at", "trash-mail.com", "trash-mail.de", "trash2009.com",
                "trashdevil.com", "trashemail.de", "trashmail.at", "trashmail.com", "trashmail.de", "trashmail.me",
                "trashmail.net", "trashmail.org", "trashymail.com", "trialmail.de", "trillianpro.com", "twinmail.de",
                "tyldd.com", "uggsrock.com", "umail.net", "uroid.com", "us.af", "venompen.com", "veryrealemail.com",
                "viditag.com", "viralplays.com", "vpn.st", "vsimcard.com", "vubby.com", "wasteland.rfc822.org", "webemail.me",
                "weg-werf-email.de", "wegwerf-emails.de", "wegwerfadresse.de", "wegwerfemail.com", "wegwerfemail.de",
                "wegwerfmail.de", "wegwerfmail.info", "wegwerfmail.net", "wegwerfmail.org", "wh4f.org", "whyspam.me",
                "willhackforfood.biz", "willselfdestruct.com", "winemaven.info", "wronghead.com", "www.e4ward.com",
                "www.mailinator.com", "wwwnew.eu", "x.ip6.li", "xagloo.com", "xemaps.com", "xents.com", "xmaily.com",
                "xoxy.net", "yep.it", "yogamaven.com", "yopmail.com", "yopmail.fr", "yopmail.net", "yourdomain.com",
                "yuurok.com", "z1p.biz", "za.com", "zehnminuten.de", "zehnminutenmail.de", "zippymail.info", "zoemail.net",
                "zomg.info", "icloud.com", 'firemailbox.club', 'mailo.fr', 'mailo.be', 'lordbank.ru', 'Herrain.com',
                'Just4fun.me', 'the23app.com', 'bareed.ws', 'ghanaports.info', 'vusra.com', 'outlook.fr', 'hi2.in', 'joba4.fr',
                'zohomail.com', 'example.com', 'contractor.com', 'email.com', "live.com", "hotmail.com", "outlook.com",
                "proton.me", "outlook.jp", "Gmail.com", "GMAIL.COM", "emitto.com", "orange.com", "boxmail.lol", "com.com",
                "post.com", "gmx.com", "gmx.fr", "http-apple.com",
            ],
            data:
                {
                    email: "",
                    password: "",
                },
            active: false,
            spinnerActive: false,
            errors: {},
            visible_done_modal: false,
            fieldsCheckActive: false,
            errorsList: [],
            personalEmailError: false,
            forbiddenSplit: '',
            reCaptchaConfirmed: ''
        };

        toastr.options = {
            closeButton: true,
            positionClass: "toast-bottom-full-width",
            showDuration: "300",
            hideDuration: "1000",
            timeOut: "8000",
            extendedTimeOut: "1000",
        }
    }

    doSubmit = async (type) => {
        await this.setState({fieldsCheckActive: true})

        let newEmail = this.state.data.email
        let split = newEmail.split('@')[1]
        //console.log('split: ', split)

        if (this.state.forbidden.includes(split) && (newEmail !== 'elerina.93@gmail.com' && newEmail !== 'milica_k_93@hotmail.com')) {
            this.setState({
                personalEmailError: true,
                forbiddenSplit: split
            })
        } else {
            setTimeout(async () => {
                let anyErrorActive = false;
                await this.state.errorsList.map(error => error ? anyErrorActive = true : '')
                if (!anyErrorActive && this.state.data.email && this.state.data.password) {
                    try {
                        await this.setState({spinnerActive: true});
                        // const resp = await userService.register(this.state.data);
                        const {email, password} = await this.state.data;
                        const resp = await userService.register(this.state.data)
                        // console.log('register response: ', resp)
                        if (!resp.error || !resp === "Email already in use") {
                            if (process.env.REACT_APP_ENVIRONMENT === 'PROD') {

                                //console.log('there is no register error')

                                const ipResponse = await http.get('https://www.cloudflare.com/cdn-cgi/trace')

                                //console.log('ipResponse: ', ipResponse)

                                const userIpObject = ipResponse.data.split('ip=')[1].split('ts')
                                const userIp = userIpObject[0].slice(0, -1)

                                //console.log('user ip: ', userIp)

                                const iubendaData = {
                                    "subject": {

                                        "email": resp.data.email,
                                        "verified": true

                                    },
                                    "legal_notices": [
                                        {
                                            "identifier": "privacy_policy"
                                        },
                                        {
                                            "identifier": "term"
                                        },
                                        {
                                            "identifier": "cookie_policy"
                                        }
                                    ],
                                    "proofs": [
                                        {
                                            "content": "registration",
                                            "form": "registration form"
                                        }
                                    ],
                                    "preferences": {
                                        "email_outreach": true,
                                        "privacy_policy": true,
                                        "phone_outreach": true,
                                        "terms": true,
                                        "cookie_policy": true
                                    },
                                    "ip_address": userIp
                                }


                                //console.log('iubenda data: ', iubendaData)
                                const iubendaResponse = await axios.post('https://consent.iubenda.com/consent', iubendaData,
                                    {
                                        headers: {
                                            'ApiKey': process.env.REACT_APP_IUBENDA_API_KEY,
                                            'Content-Type': 'application/json'
                                        }
                                    }
                                )
                                //console.log('iubendaResponse: ', iubendaResponse)
                                const iubendaUserId = await iubendaResponse.data.subject_id
                                //console.log('iubendaUserId: ', iubendaUserId)
                                localStorage.setItem("iubendaUserId", iubendaUserId);
                            }

                            if (type === 'facebook') {
                                // authService.login(email, password )
                                await login(email, password);
                                const {state} = await this.props.location;
                                await this.setState({spinnerActive: false});
                                window.location = state ? state.from.pathname : "/";
                            }
                            //console.log("OldRegister ", resp);
                            if (resp.error && type !== 'facebook') {
                                // //console.log('type i resp: ', type, resp)
                                toastr.error('Please use a different email address to register. This email address is already in use.');
                                toastr.info('If you need help registering, please contact Emitto admins.')
                                await this.setState({spinnerActive: false});
                                //This should be removed before going live
                                //this.props.history.push('/email-verification');
                            } else {

                                // this.openModal();
                                await login(email, password)
                                await this.setState({spinnerActive: false});
                                type === 'facebook' ? this.props.history.push('/insert-company') : this.props.history.push('/email-verification');
                            }
                        } else {
                            toastr.error('Email already in use!')
                            this.setState({spinnerActive: false});
                        }
                    } catch (ex) {
                        toastr.error(ex)
                        this.setState({spinnerActive: false});
                        if (ex.response && (ex.response.status === 400 || ex.response.status === 422)) {
                            const errors_obj = this.state.errors;
                            let errors = {...errors_obj};
                            //console.log(ex.response.data);
                            errors = ex.response.data.errors;
                            this.setState({errors});
                        }
                    }
                }
            }, 500)
        }
    };

    updateErrorsList = async (error, id) => {
        let errorsList = await this.state.errorsList;
        errorsList[parseInt(id) - 1] = await error;
        await this.setState({errorsList})
    }

    // handleRecaptchaV3 = (token) => {
    //     if(!this.state.reCaptchaConfirmed){
    //         this.setState({reCaptchaConfirmed: token})
    //         // let captchaResult = axios.post('https://www.google.com/recaptcha/api/siteverify?secret=6LdYliEfAAAAAPtY_fRDXSJRM7UV1J3OMVuUFg_Q&response='+token,{})
    //         console.log('captchaResult: ', captchaResult)
    //     }
    //
    // }

    handleRecaptcha = (value) => {
        this.setState({reCaptchaConfirmed: value})
    }

    componentDidMount() {
        let urlParameters = getQueryStringParams(this.props.location.search)
        let refParameter = urlParameters && urlParameters.ref ? urlParameters.ref : ''
        if (refParameter) {
            localStorage.setItem('affiliateId', refParameter);
        }
    }

    render() {
        const facebook_app_id = process.env.REACT_APP_FACEBOOK_APP_ID;

        return (
            <GoogleReCaptchaProvider reCaptchaKey="6LdYliEfAAAAAEXJoQlPfS6Y4FU2_oBzizi42YCN" useEnterprise={false}>
            <div className='onboarding-container'>
                <Header linkDisabled={true}/>
                <div className="onboarding-content">
                    <div className="onboarding-panel">
                        <h1 className='onboarding-title'>Create an account</h1>

                        <p>To create an account on Emitto You are required to use a valid business email address.</p>
                        <p className='m-m-b'>We’ll use it to send you a verification code and verify your domain.</p>
                        <p className='m-m-b'>All non-verified domains or temporary email domains will be automatically suspended.</p>
                        {/*<form onSubmit={this.handleFormSubmit}>*/}
                        <InputRegular
                            id="1"
                            label1=""
                            label2=""
                            placeholder="name@example.com"
                            type='email'
                            onChange={async (value) => await this.setState({
                                data: {
                                    ...this.state.data,
                                    email: value,
                                },
                                personalEmailError: false,
                                forbiddenSplit: ''
                            })}
                            value={this.state.data.email}
                            required={true}
                            fieldsCheckActive={this.state.fieldsCheckActive}
                            updateErrorsList={this.updateErrorsList}
                            errorMessage="Needs to be a valid business email address."

                            disableErrorHeight={this.state.personalEmailError} //just for register page

                        />
                        {
                            this.state.personalEmailError ?
                                <div className='input-error-container margin-bottom-10'>
                                    <div className="alert alert-danger" style={{padding: 0}}>
                                        {'You can not use a public email address such as <@' +
                                            this.state.forbiddenSplit + '>. for your Emitto account. Please use your business email.'}
                                    </div>
                                </div>
                                :
                                ''
                        }
                        <InputRegular
                            id="2"
                            label1=""
                            label2=""
                            placeholder="********"
                            type='password'
                            onChange={async (value) => await this.setState({
                                data: {
                                    ...this.state.data,
                                    password: value
                                }
                            })}
                            value={this.state.data.password}
                            required={true}
                            fieldsCheckActive={this.state.fieldsCheckActive}
                            updateErrorsList={this.updateErrorsList}
                            errorMessage="Password must contain minimum 8 characters. At least one character should be a number (0-9) or a special character."
                            spaceBellowInput={30}
                        />
                        {/*{this.renderInput("email", "email", 'name@example.com', false, true)}*/}
                        {/*{this.renderInput("password", "password", '********', false )}*/}

                        <div className='flex justify-content-center flex-direction-row margin-bottom-20'>
                            <ReCAPTCHA
                                sitekey="6LdwbyYcAAAAAOFICHCTHRTdaZYW2XSNKSk1vUN7"
                                onChange={this.handleRecaptcha}
                            />
                        </div>

                        {/*<GoogleReCaptcha onVerify={this.handleRecaptchaV3} />*/}

                        {!this.state.spinnerActive ?
                            <button
                                className='btn-action' onClick={() => this.doSubmit('regular')}
                                disabled={!this.state.reCaptchaConfirmed}
                            >Create</button>
                            :
                            <button className='btn-action' disabled={true}>Create <i
                                className='fa fa-spin fa-spinner'></i>
                            </button>
                        }
                        {/*this.renderRegisterButton("Create")*/}
                        {/*:*/}
                        {/*this.renderRegisterButtonSpinner("Create", "btn-action")}*/}
                        {/*</form>*/}
                        {/*<p className='text-center m-m-b m-m-t'>Or</p>*/}
                        {/*<FacebookLogin*/}
                        {/*    appId={facebook_app_id}*/}
                        {/*    autoLoad={false}*/}
                        {/*    fields="name, email, picture.type(large)"*/}
                        {/*    // scope="email, public_profile, pages_messaging, manage_pages"*/}
                        {/*    scope="email, public_profile"*/}
                        {/*    callback={this.responseFacebook}*/}
                        {/*    render={renderProps => (*/}
                        {/*        <button type="button"*/}
                        {/*                className="btn-fb  center"*/}
                        {/*                onClick={renderProps.onClick}>*/}
                        {/*            Register with Facebook*/}
                        {/*        </button>)}*/}
                        {/*/>*/}
                        <p className="panel-message text-center">Already have an account? <Link
                            to="/login"><span>Login here!</span></Link></p>
                        <div className='panel-message'>
                            <p>By registering on our website you are agreeing to our <a target='_blank'
                                href="https://emitto.io/terms-of-service"
                            >Customer Terms of Service, </a><a target='_blank' href="https://emitto.io/know-your-customer-policy/">KYC Policy, </a>
                                <a target='_blank' href="https://emitto.io/privacy-policy/">Privacy Policy, Cookie Policy.</a>
                            </p>

                        </div>
                    </div>
                </div>
            </div>
            </GoogleReCaptchaProvider>

        )
    }
}

export default Register;